import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-542509db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backgrnd" }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = {
  key: 0,
  class: "modal7"
}
const _hoisted_6 = { class: "contenedor7" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Centro ", -1))
const _hoisted_8 = { class: "contenido7" }
const _hoisted_9 = { class: "contenido7" }
const _hoisted_10 = { id: "customers" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "NOMBRE"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA")
], -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "main" }
const _hoisted_15 = {
  key: 0,
  class: "modal"
}
const _hoisted_16 = { class: "contenedor" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Filtros", -1))
const _hoisted_18 = { class: "contenido" }
const _hoisted_19 = { class: "contenido" }
const _hoisted_20 = { class: "card bg-secondary" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "grid" }
const _hoisted_23 = { class: "evaluacions" }
const _hoisted_24 = { class: "grid-fields" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Validar Afiliado")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "desde"
}, "Fecha:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "desde"
}, "Centro:", -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "radios" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"margin":"0"},
  for: "eval_nutri_1"
}, " Orden: ", -1))
const _hoisted_33 = { class: "form-check grid-radio" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "true_radio_eval_nutri_1"
}, "ASCENDENTE", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "false_radio_eval_nutri_1"
}, "DESCENDENTE", -1))
const _hoisted_36 = { class: "mycard-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ListadoComponent = _resolveComponent("ListadoComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "img",
                src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Navbar),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      ($data.showModalAseguradoras)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "search",
                      type: "search",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.searchField) = $event)),
                      class: "form-control",
                      placeholder: "Introduzca el nombre del centro",
                      onKeypress: _cache[1] || (_cache[1] = ($event: any) => ($options.buscar()))
                    }, null, 544), [
                      [_vModelText, $data.searchField]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_10, [
                      _hoisted_11,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.state.user
                    .filteredCentros, (centro, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          onClick: ($event: any) => ($options.setCentro(centro))
                        }, [
                          _createElementVNode("td", null, _toDisplayString(centro.unap), 1),
                          _createElementVNode("td", null, _toDisplayString(centro.region), 1),
                          _createElementVNode("td", null, _toDisplayString(centro.provincia), 1)
                        ], 8, _hoisted_12))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          ($data.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showModalMethod())),
                      for: "btn-modal"
                    }, "X"),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Filters, {
                        filterEvaluacions: _ctx.filterEvaluacions,
                        search: $options.search,
                        filteredEvaluacions: _ctx.filteredEvaluacions
                      }, null, 8, ["filterEvaluacions", "search", "filteredEvaluacions"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h4", null, [
                          _createTextVNode(" Evaluaciones (" + _toDisplayString($data.evaluacions.length) + ") ", 1),
                          _createElementVNode("i", {
                            style: {"cursor":"pointer"},
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (this.loadEvaluacions())),
                            class: "fas fa-sync-alt",
                            _mstvisible: "2"
                          })
                        ]),
                        (
                            this.$store.state.user.type == 'Supervisor en Sitio'
                          )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "navbar-option",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (this.$router.push('/openEvaluacions'))),
                              href: "#"
                            }, _hoisted_27))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _withDirectives(_createElementVNode("input", {
                          id: "desde",
                          type: "date",
                          onChange: _cache[5] || (_cache[5] = ($event: any) => ($options.loadEvaluacions())),
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.criterio.desde) = $event)),
                          class: "form-control"
                        }, null, 544), [
                          [_vModelText, $data.criterio.desde]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_29,
                        _withDirectives(_createElementVNode("select", {
                          disabled: "",
                          id: "id_center",
                          type: "id_center",
                          onChange: _cache[7] || (_cache[7] = ($event: any) => ($options.loadEvaluacions())),
                          onFocus: _cache[8] || (_cache[8] = ($event: any) => (this.showModalAseguradorasMethod())),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.$store.state.user.id_center) = $event)),
                          class: "form-select"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.state.user
                              .centros, (centro, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: centro.id_center
                            }, _toDisplayString(centro.unap), 9, _hoisted_30))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, this.$store.state.user.id_center]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                id: "true_radio_eval_nutri_1",
                                onChange: _cache[10] || (_cache[10] = ($event: any) => ($options.sortEvaluacions())),
                                class: "form-check-input",
                                type: "radio",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.$store.state.user.orden) = $event)),
                                value: "ASCENDENTE"
                              }, null, 544), [
                                [_vModelRadio, this.$store.state.user.orden]
                              ]),
                              _hoisted_34
                            ]),
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                onChange: _cache[12] || (_cache[12] = ($event: any) => ($options.sortEvaluacions())),
                                id: "false_radio_eval_nutri_1",
                                class: "form-check-input",
                                type: "radio",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.$store.state.user.orden) = $event)),
                                value: "DESCENDENTE"
                              }, null, 544), [
                                [_vModelRadio, this.$store.state.user.orden]
                              ]),
                              _hoisted_35
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createVNode(_component_ListadoComponent, { evaluacions: $data.evaluacions }, null, 8, ["evaluacions"]), [
                        [_vShow, !$data.cargando]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}